import { useState, useEffect, useRef } from "react";
import banner from "./images/banner1.jpg";
import { Routes, Route } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import Portfolio from './portfolio';
import BlogPage from './blog';         
import AllBlogs from './all-blogs';    
import WebDevelopment from './web-development';
import MobileAppDevelopment from './mobile-app-development';
import AiMlSolutions from './ai-ml-solutions';
import Cloud from './cloud';
import Ecommerce from './ecommerce';
import UIUX from './ui-ux';
import CRM from './crm-solutions';
import ERP from './erp-solutions';
import HRM from './hrm-solutions';
import LMS from './lms-solutions';
import POS from './pos-solutions';
import SAAS from './saas-platform';
import Healthcare from './healthcare-solution';
import Fintech from './fintech-solution';
import Edtech from './edtech-solution';
import Realestate from './realestate-solution';
import Logistic from './logistic-solution';
import Retail from './retail-ecommerce-solution';

const STATS = [
  { value: "1560+", label: "Projects Delivered" },
  { value: "20+", label: "Countries Served" },
  { value: "98%", label: "Client Retention" },
  { value: "7+ Yrs", label: "In Industry" },
];

const SERVICES = [
  {
    icon: "🌐",
    title: "Web & Software Development",
    desc: "Custom-built web apps and enterprise software engineered for performance, security, and scale.",
    tags: ["React", "Node.js", "Laravel", "Next.js"],
    color: "#3B82F6",
    link: "/web-development",
  },
  {
    icon: "📱",
    title: "Mobile App Development",
    desc: "High-performing iOS & Android apps with seamless UX from concept to App Store deployment.",
    tags: ["Flutter", "React Native", "iOS", "Android"],
    color: "#8B5CF6",
    link: "/mobile-app-development",
  },
  {
    icon: "🤖",
    title: "AI & ML Solutions",
    desc: "Transform operations with intelligent automation, LLMs, chatbots, and predictive analytics.",
    tags: ["ChatGPT", "TensorFlow", "Python", "Gen AI"],
    color: "#10B981",
    link:"/ai-ml-solutions",
  },
  {
    icon: "🛒",
    title: "E-Commerce Solutions",
    desc: "Scalable online stores with secure payments, intuitive UI, and conversion-optimized design.",
    tags: ["Shopify", "WooCommerce", "Magento"],
    color: "#F59E0B",
    link:"/ecommerce",
  },
  {
    icon: "☁️",
    title: "Cloud & DevOps",
    desc: "End-to-end cloud infrastructure, CI/CD pipelines, and containerization for zero-downtime delivery.",
    tags: ["AWS", "Docker", "Kubernetes", "GCP"],
    color: "#EF4444",
    link:"/cloud",
  },
  {
    icon: "🎨",
    title: "UI/UX Design",
    desc: "Research-driven, pixel-perfect designs that delight users and drive measurable engagement.",
    tags: ["Figma", "Prototyping", "Design Systems"],
    color: "#EC4899",
    link:"/ui-ux",
  },
];

const TECH_CATEGORIES = [
  {
    label: "Frontend",
    color: "#3B82F6",
    bg: "#EFF6FF",
    techs: [
      { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg", color: "#61DAFB" },
      { name: "Next.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg", color: "#000000" },
      { name: "Angular", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/angularjs/angularjs-original.svg", color: "#DD0031" },
      { name: "Vue.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg", color: "#42B883" },
      { name: "TypeScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg", color: "#3178C6" },
      { name: "Tailwind", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg", color: "#06B6D4" },
    ],
  },
  {
    label: "Backend",
    color: "#10B981",
    bg: "#F0FDF4",
    techs: [
      { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg", color: "#339933" },
      { name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg", color: "#3776AB" },
      { name: "Laravel", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg", color: "#FF2D20" },
      { name: "Express.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg", color: "#000000" },
      { name: "GraphQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/graphql/graphql-plain.svg", color: "#E10098" },
      { name: "PHP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg", color: "#777BB4" },
    ],
  },
  {
    label: "Mobile",
    color: "#8B5CF6",
    bg: "#F5F3FF",
    techs: [
      { name: "Flutter", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg", color: "#02569B" },
      { name: "React Native", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg", color: "#61DAFB" },
      { name: "Swift", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/swift/swift-original.svg", color: "#FA7343" },
      { name: "Kotlin", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kotlin/kotlin-original.svg", color: "#7F52FF" },
      { name: "Dart", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dart/dart-original.svg", color: "#0175C2" },
      { name: "Android", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/android/android-original.svg", color: "#3DDC84" },
    ],
  },
  {
    label: "Database",
    color: "#F59E0B",
    bg: "#FFFBEB",
    techs: [
      { name: "MongoDB", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg", color: "#47A248" },
      { name: "MySQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg", color: "#4479A1" },
      { name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg", color: "#4169E1" },
      { name: "Redis", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg", color: "#DC382D" },
      { name: "Firebase", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-plain.svg", color: "#FFCA28" },
      { name: "Supabase", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/supabase/supabase-original.svg", color: "#3ECF8E" },
    ],
  },
  {
    label: "Cloud & DevOps",
    color: "#EF4444",
    bg: "#FEF2F2",
    techs: [
      { name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg", color: "#FF9900" },
      { name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg", color: "#2496ED" },
      { name: "Kubernetes", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kubernetes/kubernetes-plain.svg", color: "#326CE5" },
      { name: "GCP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/googlecloud/googlecloud-original.svg", color: "#4285F4" },
      { name: "GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg", color: "#181717" },
      { name: "Jenkins", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jenkins/jenkins-original.svg", color: "#D33833" },
    ],
  },
  {
    label: "Design & AI",
    color: "#EC4899",
    bg: "#FDF2F8",
    techs: [
      { name: "Figma", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/figma/figma-original.svg", color: "#F24E1E" },
      { name: "TensorFlow", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original.svg", color: "#FF6F00" },
      { name: "PyTorch", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original.svg", color: "#EE4C2C" },
      { name: "OpenCV", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/opencv/opencv-original.svg", color: "#5C3EE8" },
      { name: "Sass", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/sass/sass-original.svg", color: "#CC6699" },
      { name: "Adobe XD", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/xd/xd-plain.svg", color: "#FF61F6" },
    ],
  },
];

const PROCESS = [
  { step: "01", title: "Discovery & Strategy", desc: "We deep-dive into your goals, market, and competition to craft a winning roadmap." },
  { step: "02", title: "Design & Prototype", desc: "Wireframes evolve into interactive prototypes validated with real user feedback." },
  { step: "03", title: "Agile Development", desc: "Sprints, daily standups, and transparent progress — built right, built fast." },
  { step: "04", title: "QA & Testing", desc: "Rigorous automated and manual testing across devices, browsers, and edge cases." },
  { step: "05", title: "Launch & Scale", desc: "Smooth deployment with monitoring, optimization, and dedicated post-launch support." },
];

const TESTIMONIALS = [
  {
    name: "Sarah Mitchell",
    role: "CEO, HealthTrack",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&auto=format",
    text: "Techvanto transformed our healthcare platform from a fragmented system into a seamless digital experience. Their team's expertise in both AI and UX is genuinely world-class.",
    rating: 5,
  },
  {
    name: "Arjun Mehta",
    role: "CTO, FinEdge",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&auto=format",
    text: "From architecture decisions to the final pixel, Techvanto delivered beyond expectations. Our app handles 50k+ daily users flawlessly since launch.",
    rating: 5,
  },
  {
    name: "Emily Zhao",
    role: "Founder, LearningHub",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&auto=format",
    text: "The LMS they built scaled our EdTech startup from 200 to 20,000 students. Incredible technical depth paired with real business understanding.",
    rating: 5,
  },
];

const BLOG_POSTS = [
  {
    category: "AI & ML",
    title: "How Generative AI Is Redefining Enterprise Software in 2025",
    excerpt: "From intelligent document processing to code generation, GenAI is moving from hype to hard ROI.",
    img: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=480&h=280&fit=crop&auto=format",
    date: "Apr 10, 2025",
    readTime: "5 min",
    link: "/blog/generative-ai-enterprise",
  },
  {
    category: "Mobile",
    title: "Flutter vs React Native in 2025: Which to Choose?",
    excerpt: "A pragmatic side-by-side comparison covering performance, ecosystem maturity, and team considerations.",
    img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=480&h=280&fit=crop&auto=format",
    date: "Mar 28, 2025",
    readTime: "7 min",
    link: "/blog/flutter-vs-react-native",
  },
  {
    category: "Cloud",
    title: "Kubernetes Cost Optimization: 8 Strategies That Actually Work",
    excerpt: "Real-world tactics to slash cloud spend without sacrificing reliability or developer velocity.",
    img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=480&h=280&fit=crop&auto=format",
    date: "Mar 15, 2025",
    readTime: "6 min",
    link: "/blog/kubernetes-cost-optimization",
  },
];

const CLIENTS = [
  "Columbus University", "GetMyProperty", "TravelAmour", "HealthyPinto",
  "eSrot", "MetroShop", "Wellnivo", "CollegeClue",
];

function TechIcon({ logo, name, color }) {
  const [hov, setHov] = useState(false);
  return (
    <div style={{ position: "relative", display: "inline-flex" }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <div style={{
        width: 32, height: 32, borderRadius: 8,
        background: hov ? `${color}22` : `${color}12`,
        border: `1.5px solid ${hov ? color : color + "30"}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "all .2s", transform: hov ? "scale(1.15)" : "scale(1)",
        boxShadow: hov ? `0 4px 12px ${color}40` : "none",
        cursor: "default",
      }}>
        <img src={logo} alt={name} style={{ width: 18, height: 18, objectFit: "contain" }}
          onError={e => { e.target.style.display = "none"; e.target.parentNode.innerHTML = `<span style='font-size:11px;font-weight:800;color:${color}'>${name[0]}</span>`; }} />
      </div>
      {hov && (
        <div style={{
          position: "absolute", bottom: "110%", left: "50%", transform: "translateX(-50%)",
          background: "#0F172A", color: "#fff", fontSize: 10, fontWeight: 600,
          padding: "4px 8px", borderRadius: 6, whiteSpace: "nowrap",
          pointerEvents: "none", zIndex: 999,
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          animation: "fadeIn .15s ease",
        }}>
          {name}
          <div style={{ position: "absolute", top: "100%", left: "50%", transform: "translateX(-50%)", width: 0, height: 0, borderLeft: "4px solid transparent", borderRight: "4px solid transparent", borderTop: "4px solid #0F172A" }} />
        </div>
      )}
    </div>
  );
}

function Badge({ children, color = "#3B82F6" }) {
  return (
    <span style={{
      display: "inline-block", padding: "3px 10px",
      borderRadius: 99, fontSize: 11, fontWeight: 600,
      background: color + "18", color, border: `1px solid ${color}33`,
      letterSpacing: ".04em", textTransform: "uppercase",
    }}>{children}</span>
  );
}

function StarRating({ count = 5 }) {
  return (
    <span style={{ color: "#F59E0B", fontSize: 14 }}>
      {"★".repeat(count)}{"☆".repeat(5 - count)}
    </span>
  );
}

function Hero() {
  const [typed, setTyped] = useState("");
  const phrases = ["Web Experiences.", "Mobile Apps.", "AI Solutions.", "SaaS Platforms."];
  const [pIdx, setPIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const phrase = phrases[pIdx];
    const timeout = setTimeout(() => {
      if (!deleting) {
        setTyped(phrase.slice(0, charIdx + 1));
        if (charIdx + 1 === phrase.length) {
          setTimeout(() => setDeleting(true), 1800);
        } else setCharIdx(c => c + 1);
      } else {
        setTyped(phrase.slice(0, charIdx - 1));
        if (charIdx === 0) {
          setDeleting(false);
          setPIdx(p => (p + 1) % phrases.length);
        } else setCharIdx(c => c - 1);
      }
    }, deleting ? 45 : 90);
    return () => clearTimeout(timeout);
  }, [charIdx, deleting, pIdx]);

  return (
    <section style={{
      minHeight: "100vh", paddingTop: 120,
      background: "linear-gradient(160deg,#EFF6FF 0%,#F0FDF4 40%,#FFF7ED 100%)",
      display: "flex", alignItems: "center", position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", top: -80, right: -80, width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle,rgba(59,130,246,.12),transparent 70%)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -100, left: -100, width: 600, height: 600, borderRadius: "50%", background: "radial-gradient(circle,rgba(16,185,129,.09),transparent 70%)", pointerEvents: "none" }} />
      <div style={{
        position: "absolute", inset: 0, pointerEvents: "none",
        backgroundImage: "linear-gradient(rgba(59,130,246,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(59,130,246,.04) 1px,transparent 1px)",
        backgroundSize: "60px 60px",
      }} />

      <div className="hero-grid section-pad" style={{ maxWidth: 1280, margin: "0 auto", padding: "0 40px 80px", width: "100%" }}>
        <div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#EFF6FF", border: "1px solid #BFDBFE", borderRadius: 99, padding: "6px 16px", marginBottom: 24 }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#3B82F6", display: "inline-block", animation: "pulse 2s infinite" }} />
            <span style={{ fontSize: 13, fontWeight: 600, color: "#1E40AF" }}>🚀 Trusted by 1,560+ Global Clients</span>
          </div>
          <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(36px,5vw,62px)", fontWeight: 800, color: "#0F172A", lineHeight: 1.12, marginBottom: 12 }}>
            We Build World-Class
          </h1>
          <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(36px,5vw,62px)", fontWeight: 800, lineHeight: 1.12, marginBottom: 24, minHeight: 80 }}>
            <span style={{ background: "linear-gradient(135deg,#1E3A8A,#3B82F6,#06B6D4)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
              {typed}<span style={{ animation: "blink 1s infinite", borderRight: "3px solid #3B82F6" }}>&nbsp;</span>
            </span>
          </h1>
          <p style={{ fontSize: 17, color: "#6B7280", lineHeight: 1.75, maxWidth: 520, marginBottom: 36 }}>
            We deliver smart, scalable enterprise-ready web & mobile solutions that turn your ideas into powerful digital experiences. From startups to Fortune 500 — we build what matters.
          </p>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
            <a href="#services" style={{
              background: "linear-gradient(135deg,#1E3A8A,#3B82F6)", color: "#fff",
              padding: "14px 28px", borderRadius: 10, fontWeight: 700, fontSize: 15,
              textDecoration: "none", boxShadow: "0 6px 20px rgba(59,130,246,.4)",
              transition: "transform .2s,box-shadow .2s", display: "inline-flex", alignItems: "center", gap: 8,
              fontFamily: "'Sora',sans-serif",
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 10px 28px rgba(59,130,246,.5)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(59,130,246,.4)"; }}
            >Explore Services →</a>
            <a href="#contact"
              onClick={e => { e.preventDefault(); document.getElementById("contact").scrollIntoView({ behavior: "smooth", block: "start" }); }}
              style={{
                background: "#fff", color: "#1E3A8A",
                padding: "14px 28px", borderRadius: 10, fontWeight: 700, fontSize: 15,
                textDecoration: "none", border: "2px solid #BFDBFE",
                transition: "all .2s", display: "inline-flex", alignItems: "center", gap: 8,
                fontFamily: "'Sora',sans-serif", cursor: "pointer",
              }}
              onMouseEnter={e => { e.currentTarget.style.background = "#EFF6FF"; e.currentTarget.style.borderColor = "#93C5FD"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#BFDBFE"; }}
            >💬 Talk to Experts</a>
          </div>
          <div style={{ display: "flex", gap: 20, marginTop: 40, flexWrap: "wrap" }}>
            {[["⭐", "4.9/5", "Clutch Rating"], ["🏆", "Top 1%", "Developer Agency"], ["🌍", "20+", "Countries"]].map(([icon, val, lbl]) => (
              <div key={lbl} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 20 }}>{icon}</span>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 15, color: "#0F172A", fontFamily: "'Sora',sans-serif" }}>{val}</div>
                  <div style={{ fontSize: 11, color: "#9CA3AF", fontWeight: 500 }}>{lbl}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Hero Vector Illustration */}
        <div className="hero-svg-wrap" style={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img
            src={banner}
            alt="Techvanto Banner"
            style={{
              width: "100%",
              maxWidth: 1000,
              height: 490,
              borderRadius: 20,
              objectFit: "contain",
              boxShadow: "0 20px 50px rgba(0,0,0,0.15)"
            }} 
          />

          <div className="hero-float-left" style={{
            position: "absolute", top: 18, left: -18,
            background: "#fff", borderRadius: 18, padding: "14px 20px",
            boxShadow: "0 12px 40px rgba(16,185,129,0.22), 0 2px 8px rgba(0,0,0,0.08)",
            display: "flex", alignItems: "center", gap: 14,
            border: "1.5px solid #D1FAE5",
            animation: "float 3s ease-in-out infinite",
            minWidth: 220, zIndex: 10,
          }}>
            <div style={{
              width: 44, height: 44, borderRadius: "50%",
              background: "linear-gradient(135deg,#10B981,#059669)",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 4px 14px rgba(16,185,129,0.4)", flexShrink: 0,
            }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 14, color: "#065F46", fontFamily: "'Sora',sans-serif", lineHeight: 1.2 }}>
                🎉 Project Delivered!
              </div>
              <div style={{ fontSize: 11.5, color: "#6B7280", marginTop: 3, fontWeight: 500 }}>
                E-Commerce Platform • Just now
              </div>
              <div style={{ display: "flex", gap: 4, marginTop: 6 }}>
                {["React","Node","AWS"].map(t => (
                  <span key={t} style={{ fontSize: 9.5, fontWeight: 700, background: "#D1FAE5", color: "#065F46", padding: "2px 7px", borderRadius: 99 }}>{t}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="hero-float-right" style={{
            position: "absolute", top: 14, right: -22,
            background: "linear-gradient(135deg,#1E3A8A,#3B82F6)",
            borderRadius: 18, padding: "16px 22px",
            boxShadow: "0 12px 36px rgba(59,130,246,0.4)",
            animation: "float 3.5s ease-in-out infinite .5s",
            zIndex: 10, textAlign: "center",
          }}>
            <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 900, fontSize: 26, color: "#fff", lineHeight: 1 }}>1,560+</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,.8)", fontWeight: 500, marginTop: 4 }}>Happy Clients 🎉</div>
          </div>

          <div className="hero-float-br" style={{
            position: "absolute", bottom: 10, right: -18,
            background: "#fff", borderRadius: 16, padding: "12px 18px",
            boxShadow: "0 8px 28px rgba(0,0,0,0.1)", border: "1.5px solid #FEF3C7",
            animation: "float 4s ease-in-out infinite 1s", zIndex: 10,
          }}>
            <div style={{ display: "flex", gap: 3, marginBottom: 4 }}>
              {[1,2,3,4,5].map(i => <span key={i} style={{ color: "#F59E0B", fontSize: 14 }}>★</span>)}
            </div>
            <div style={{ fontWeight: 800, fontSize: 13, color: "#0F172A", fontFamily: "'Sora',sans-serif" }}>4.9 / 5.0</div>
            <div style={{ fontSize: 10, color: "#9CA3AF" }}>Clutch Rating</div>
          </div>

          <div className="float-card-tech" style={{
            position: "absolute", bottom: 8, left: -14,
            background: "#fff", borderRadius: 16, padding: "14px 16px",
            boxShadow: "0 8px 28px rgba(0,0,0,0.12)", border: "1px solid #E5E7EB",
            animation: "float 3.8s ease-in-out infinite .3s", zIndex: 10, minWidth: 210,
          }}>
            <div style={{ fontSize: 10, color: "#9CA3AF", fontWeight: 700, marginBottom: 10, textTransform: "uppercase", letterSpacing: ".07em" }}>
              🛠 Tech Stack — 40+ Technologies
            </div>
            <div style={{ display: "flex", gap: 6, marginBottom: 6, flexWrap: "wrap" }}>
              {[
                { logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg", name: "React", color: "#61DAFB" },
                { logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg", name: "Next.js", color: "#000" },
                { logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg", name: "Node.js", color: "#339933" },
                { logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg", name: "Python", color: "#3776AB" },
                { logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg", name: "TypeScript", color: "#3178C6" },
                { logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg", name: "Flutter", color: "#02569B" },
              ].map((t, i) => (
                <TechIcon key={i} {...t} />
              ))}
            </div>
            <div style={{ marginTop: 8, fontSize: 10, color: "#9CA3AF", textAlign: "right", fontWeight: 600 }}>
              +34 more technologies →
            </div>
          </div>
        </div>
      </div>

      <div style={{ position: "absolute", bottom: 28, left: "50%", transform: "translateX(-50%)", display: "flex", flexDirection: "column", alignItems: "center", gap: 6, opacity: .5 }}>
        <span style={{ fontSize: 11, color: "#6B7280", letterSpacing: ".1em", textTransform: "uppercase" }}>Scroll</span>
        <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom,#6B7280,transparent)" }} />
      </div>
    </section>
  );
}

function ClientLogos() {
  return (
    <section style={{ background: "#fff", padding: "36px 0", borderBottom: "1px solid #F3F4F6", overflow: "hidden" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 40px", textAlign: "center", marginBottom: 20 }}>
        <p style={{ fontSize: 13, color: "#9CA3AF", fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase" }}>Trusted by innovative companies worldwide</p>
      </div>
      <div style={{ display: "flex", gap: 48, animation: "marquee 22s linear infinite", width: "max-content" }}>
        {[...CLIENTS, ...CLIENTS].map((c, i) => (
          <div key={i} style={{
            padding: "8px 24px", background: "#F9FAFB", borderRadius: 10,
            border: "1px solid #F3F4F6", whiteSpace: "nowrap",
            fontWeight: 700, fontSize: 14, color: "#9CA3AF",
            transition: "all .2s",
          }}
            onMouseEnter={e => { e.currentTarget.style.color = "#374151"; e.currentTarget.style.borderColor = "#E5E7EB"; }}
            onMouseLeave={e => { e.currentTarget.style.color = "#9CA3AF"; e.currentTarget.style.borderColor = "#F3F4F6"; }}
          >{c}</div>
        ))}
      </div>
    </section>
  );
}

function Stats() {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: .3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ background: "linear-gradient(135deg,#1E3A8A 0%,#1E40AF 50%,#3B82F6 100%)", padding: "72px 40px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: 40, textAlign: "center" }}>
        {STATS.map((s, i) => (
          <div key={s.label} style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(20px)", transition: `all .6s ease ${i * .12}s` }}>
            <div style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(36px,4vw,52px)", fontWeight: 900, color: "#fff", lineHeight: 1 }}>{s.value}</div>
            <div style={{ fontSize: 15, color: "rgba(255,255,255,.7)", marginTop: 8, fontWeight: 500 }}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

function Services() {
  const [hovered, setHovered] = useState(null);
  return (
    <section id="services" style={{ padding: "96px 40px", background: "#F8FAFC" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <Badge color="#3B82F6">Our Services</Badge>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 800, color: "#0F172A", margin: "16px 0 16px" }}>
            End-to-End Digital Solutions
          </h2>
          <p style={{ color: "#6B7280", maxWidth: 560, margin: "0 auto", fontSize: 16, lineHeight: 1.7 }}>
            From ideation to deployment and beyond — we cover every aspect of your digital journey with precision and passion.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))", gap: 24 }}>
          {SERVICES.map((s, i) => (
            <a key={s.title} href={s.link || "#"} style={{ textDecoration: "none", color: "inherit", display: "block" }}>
              <div
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                style={{
                  background: "#fff", borderRadius: 20, padding: 32,
                  border: `2px solid ${hovered === i ? s.color : "#F1F5F9"}`,
                  boxShadow: hovered === i ? `0 24px 64px ${s.color}22` : "0 2px 12px rgba(0,0,0,.04)",
                  transition: "all .3s ease", cursor: "pointer",
                  transform: hovered === i ? "translateY(-6px)" : "none",
                  height: "100%"
                }}>
                <div style={{
                  width: 56, height: 56, borderRadius: 14,
                  background: `${s.color}15`, display: "flex", alignItems: "center",
                  justifyContent: "center", fontSize: 26, marginBottom: 20,
                  border: `1px solid ${s.color}25`,
                }}>{s.icon}</div>
                <h3 style={{ fontFamily: "'Sora',sans-serif", fontSize: 19, fontWeight: 700, color: "#0F172A", marginBottom: 10 }}>{s.title}</h3>
                <p style={{ color: "#6B7280", fontSize: 14.5, lineHeight: 1.7, marginBottom: 20 }}>{s.desc}</p>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {s.tags.map(t => <Badge key={t} color={s.color}>{t}</Badge>)}
                </div>
                <div style={{
                  marginTop: 24, color: s.color, fontWeight: 700, fontSize: 14,
                  display: "flex", alignItems: "center", gap: 6,
                  opacity: hovered === i ? 1 : 0, transition: "opacity .2s",
                }}>Learn More →</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

function TechStack() {
  const [activeTab, setActiveTab] = useState(0);
  const [hoveredTech, setHoveredTech] = useState(null);
  const activeCat = TECH_CATEGORIES[activeTab];

  return (
    <section style={{ padding: "96px 0", background: "#fff", overflow: "hidden" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 40px" }}>
        <div style={{ textAlign: "center", marginBottom: 52 }}>
          <Badge color="#8B5CF6">Technologies</Badge>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 800, color: "#0F172A", margin: "16px 0 14px" }}>
            Powered by Modern Tech Stack
          </h2>
          <p style={{ color: "#6B7280", maxWidth: 520, margin: "0 auto", fontSize: 16, lineHeight: 1.75 }}>
            We leverage best-in-class technologies across every layer — frontend, backend, mobile, cloud, and AI — to build resilient, future-proof solutions.
          </p>
        </div>

        <div style={{
          display: "flex", justifyContent: "center", gap: 10,
          flexWrap: "wrap", marginBottom: 44,
        }}>
          {TECH_CATEGORIES.map((cat, i) => (
            <button key={cat.label} onClick={() => { setActiveTab(i); setHoveredTech(null); }}
              style={{
                padding: "10px 22px", borderRadius: 99, fontWeight: 700,
                fontSize: 13.5, cursor: "pointer", border: "2px solid",
                transition: "all .25s ease", fontFamily: "'Sora',sans-serif",
                letterSpacing: ".02em",
                background: activeTab === i ? cat.color : "#fff",
                borderColor: activeTab === i ? cat.color : "#E5E7EB",
                color: activeTab === i ? "#fff" : "#6B7280",
                boxShadow: activeTab === i ? `0 6px 20px ${cat.color}40` : "none",
                transform: activeTab === i ? "translateY(-1px)" : "none",
              }}>
              {cat.label}
            </button>
          ))}
        </div>

        <div style={{
          display: "flex", alignItems: "center", gap: 14, marginBottom: 32,
          padding: "14px 24px", borderRadius: 14,
          background: activeCat.bg, border: `1px solid ${activeCat.color}25`,
        }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: activeCat.color, flexShrink: 0 }} />
          <span style={{ fontWeight: 700, fontSize: 14, color: activeCat.color, fontFamily: "'Sora',sans-serif" }}>
            {activeCat.label} Technologies
          </span>
          <span style={{ fontSize: 13, color: "#9CA3AF" }}>— {activeCat.techs.length} tools & frameworks</span>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
          gap: 18,
        }}>
          {activeCat.techs.map((tech, i) => (
            <div key={tech.name}
              onMouseEnter={() => setHoveredTech(i)}
              onMouseLeave={() => setHoveredTech(null)}
              style={{
                display: "flex", flexDirection: "column", alignItems: "center",
                gap: 14, padding: "32px 20px 24px", borderRadius: 20,
                border: `2px solid ${hoveredTech === i ? tech.color : "#F1F5F9"}`,
                background: hoveredTech === i ? `${tech.color}08` : "#FAFAFA",
                boxShadow: hoveredTech === i ? `0 12px 36px ${tech.color}28` : "0 1px 4px rgba(0,0,0,.04)",
                transition: "all .28s cubic-bezier(.4,0,.2,1)",
                transform: hoveredTech === i ? "translateY(-6px) scale(1.03)" : "none",
                cursor: "default",
                animation: `fadeIn .35s ease ${i * .06}s both`,
                position: "relative", overflow: "hidden",
              }}>
              <div style={{
                position: "absolute", inset: 0,
                background: `radial-gradient(circle at center, ${tech.color}12 0%, transparent 70%)`,
                opacity: hoveredTech === i ? 1 : 0,
                transition: "opacity .3s",
                pointerEvents: "none",
              }} />
              <div style={{
                width: 72, height: 72,
                display: "flex", alignItems: "center", justifyContent: "center",
                borderRadius: 18,
                background: hoveredTech === i ? `${tech.color}15` : "#fff",
                border: `1px solid ${hoveredTech === i ? tech.color + "30" : "#E5E7EB"}`,
                boxShadow: hoveredTech === i ? `0 4px 16px ${tech.color}25` : "0 1px 4px rgba(0,0,0,.06)",
                transition: "all .28s",
                flexShrink: 0,
              }}>
                <img
                  src={tech.logo}
                  alt={tech.name}
                  style={{
                    width: 44, height: 44, objectFit: "contain",
                    transition: "transform .28s",
                    transform: hoveredTech === i ? "scale(1.1)" : "scale(1)",
                  }}
                  onError={e => {
                    e.target.style.display = "none";
                    e.target.parentNode.innerHTML = `<span style="font-size:28px;font-weight:900;color:${tech.color}">${tech.name[0]}</span>`;
                  }}
                />
              </div>
              <div style={{ textAlign: "center", position: "relative" }}>
                <div style={{
                  fontSize: 13.5, fontWeight: 700, color: hoveredTech === i ? tech.color : "#1E293B",
                  fontFamily: "'Sora',sans-serif", transition: "color .25s", marginBottom: 2,
                }}>{tech.name}</div>
                {hoveredTech === i && (
                  <div style={{
                    fontSize: 10, color: tech.color, fontWeight: 600,
                    letterSpacing: ".06em", textTransform: "uppercase",
                    opacity: .8,
                  }}>Expert Level</div>
                )}
              </div>
              <div style={{
                position: "absolute", bottom: 0, left: 0, right: 0,
                height: 3, borderRadius: "0 0 18px 18px",
                background: `linear-gradient(90deg, ${tech.color}, ${tech.color}80)`,
                transform: hoveredTech === i ? "scaleX(1)" : "scaleX(0)",
                transformOrigin: "left",
                transition: "transform .3s cubic-bezier(.4,0,.2,1)",
              }} />
            </div>
          ))}
        </div>

        <div style={{ marginTop: 64, overflow: "hidden", position: "relative" }}>
          <div style={{ marginBottom: 16, textAlign: "center" }}>
            <span style={{ fontSize: 12, color: "#C4C9D4", fontWeight: 600, letterSpacing: ".1em", textTransform: "uppercase" }}>
              All Technologies We Work With
            </span>
          </div>
          <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 80, background: "linear-gradient(90deg,#fff,transparent)", zIndex: 2, pointerEvents: "none" }} />
          <div style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 80, background: "linear-gradient(-90deg,#fff,transparent)", zIndex: 2, pointerEvents: "none" }} />
          <div style={{ display: "flex", gap: 20, animation: "marquee 28s linear infinite", width: "max-content" }}>
            {[...TECH_CATEGORIES.flatMap(c => c.techs), ...TECH_CATEGORIES.flatMap(c => c.techs)].map((tech, i) => (
              <div key={i} style={{
                display: "flex", alignItems: "center", gap: 10,
                padding: "10px 20px", background: "#F8FAFC",
                borderRadius: 99, border: "1px solid #F1F5F9",
                whiteSpace: "nowrap", flexShrink: 0,
                transition: "all .2s",
              }}>
                <img src={tech.logo} alt={tech.name} style={{ width: 22, height: 22, objectFit: "contain" }}
                  onError={e => { e.target.style.display = "none"; }} />
                <span style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7280" }}>{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function Process() {
  return (
    <section style={{ padding: "96px 40px", background: "linear-gradient(160deg,#F0FDF4,#EFF6FF)" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 64 }}>
          <Badge color="#10B981">How We Work</Badge>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 800, color: "#0F172A", margin: "16px 0 16px" }}>
            Our Proven Process
          </h2>
          <p style={{ color: "#6B7280", maxWidth: 500, margin: "0 auto", fontSize: 16 }}>
            A battle-tested 5-stage framework that delivers exceptional digital products on time, every time.
          </p>
        </div>
        <div className="process-grid">
          <div className="process-line" style={{ position: "absolute", top: 44, left: "10%", right: "10%", height: 2, background: "linear-gradient(90deg,#BFDBFE,#A7F3D0)", zIndex: 0 }} />
          {PROCESS.map((p, i) => (
            <div key={p.step} style={{ textAlign: "center", padding: "0 16px", position: "relative", zIndex: 1, animation: `fadeIn .5s ease ${i * .12}s both` }}>
              <div style={{
                width: 88, height: 88, borderRadius: "50%", margin: "0 auto 24px",
                background: "linear-gradient(135deg,#1E3A8A,#3B82F6)",
                display: "flex", alignItems: "center", justifyContent: "center",
                boxShadow: "0 8px 28px rgba(59,130,246,.3)", border: "4px solid #fff",
              }}>
                <span style={{ fontFamily: "'Sora',sans-serif", fontWeight: 900, fontSize: 20, color: "#fff" }}>{p.step}</span>
              </div>
              <h3 style={{ fontFamily: "'Sora',sans-serif", fontSize: 16, fontWeight: 700, color: "#0F172A", marginBottom: 10 }}>{p.title}</h3>
              <p style={{ fontSize: 13.5, color: "#6B7280", lineHeight: 1.65 }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function About() {
  return (
    <section id="about" style={{ padding: "96px 40px", background: "#fff" }}>
      <div className="about-grid section-pad" style={{ maxWidth: 1280, margin: "0 auto", padding: "0 40px" }}>
        <div style={{ position: "relative" }}>
          <img
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=580&h=480&fit=crop&auto=format"
            alt="Our team"
            style={{ width: "100%", borderRadius: 24, boxShadow: "0 24px 72px rgba(0,0,0,.14)", objectFit: "cover" }}
          />
          <div style={{
            position: "absolute", bottom: -20, right: -20,
            background: "linear-gradient(135deg,#1E3A8A,#3B82F6)",
            borderRadius: 20, padding: "24px 28px", color: "#fff",
            boxShadow: "0 16px 48px rgba(59,130,246,.4)",
          }}>
            <div style={{ fontFamily: "'Sora',sans-serif", fontSize: 36, fontWeight: 900 }}>7+</div>
            <div style={{ fontSize: 13, opacity: .85 }}>Years of Excellence</div>
          </div>
          <div style={{
            position: "absolute", top: -16, left: -16,
            background: "#fff", borderRadius: 16, padding: "14px 18px",
            boxShadow: "0 8px 32px rgba(0,0,0,.1)", border: "1px solid #E5E7EB",
          }}>
            <div style={{ fontFamily: "'Sora',sans-serif", fontSize: 22, fontWeight: 800, color: "#10B981" }}>98%</div>
            <div style={{ fontSize: 11, color: "#6B7280" }}>Retention Rate</div>
          </div>
        </div>
        <div>
          <Badge color="#3B82F6">About Techvanto</Badge>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,3.5vw,42px)", fontWeight: 800, color: "#0F172A", margin: "16px 0 20px", lineHeight: 1.2 }}>
            Your Digital Growth Partner
          </h2>
          <p style={{ color: "#6B7280", fontSize: 16, lineHeight: 1.8, marginBottom: 16 }}>
            Techvanto is a leading technology company empowering businesses across 20+ countries with innovative web, mobile, and AI solutions. We blend deep technical expertise with strategic business thinking.
          </p>
          <p style={{ color: "#6B7280", fontSize: 16, lineHeight: 1.8, marginBottom: 32 }}>
            From agile startups to global enterprises, we've shipped 1,560+ projects that drive measurable results — more users, better retention, and real revenue growth.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 36 }}>
            {[
              ["🎯", "Goal-Oriented", "Every decision aligns with your KPIs and business objectives."],
              ["⚡", "Agile Delivery", "Rapid sprints with transparent progress and on-time launches."],
              ["🔒", "Secure by Default", "Enterprise-grade security baked into every layer."],
              ["🤝", "Long-Term Partner", "We stay with you from MVP all the way to scale."],
            ].map(([icon, title, desc]) => (
              <div key={title} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div style={{ fontSize: 20, flexShrink: 0 }}>{icon}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: "#0F172A", marginBottom: 4, fontFamily: "'Sora',sans-serif" }}>{title}</div>
                  <div style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.5 }}>{desc}</div>
                </div>
              </div>
            ))}
          </div>
          <a href="#contact" style={{
            background: "linear-gradient(135deg,#1E3A8A,#3B82F6)", color: "#fff",
            padding: "13px 28px", borderRadius: 10, fontWeight: 700, fontSize: 15,
            textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8,
            boxShadow: "0 6px 20px rgba(59,130,246,.35)", fontFamily: "'Sora',sans-serif",
          }}>Let's Build Together →</a>
        </div>
      </div>
    </section>
  );
}

function Testimonials() {
  const [active, setActive] = useState(0);
  return (
    <section style={{ padding: "96px 40px", background: "#F8FAFC" }}>
      <div style={{ maxWidth: 1000, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <Badge color="#EC4899">Testimonials</Badge>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,44px)", fontWeight: 800, color: "#0F172A", margin: "16px 0" }}>
            What Our Clients Say
          </h2>
        </div>
        <div style={{
          background: "#fff", borderRadius: 24, padding: "48px 56px",
          boxShadow: "0 8px 48px rgba(0,0,0,.08)", border: "1px solid #F1F5F9",
          textAlign: "center", minHeight: 280,
        }}>
          <div style={{ fontSize: 40, color: "#E5E7EB", marginBottom: 16, lineHeight: 1 }}>"</div>
          <p style={{ fontSize: 18, color: "#374151", lineHeight: 1.8, maxWidth: 680, margin: "0 auto 28px", fontStyle: "italic" }}>
            {TESTIMONIALS[active].text}
          </p>
          <StarRating count={TESTIMONIALS[active].rating} />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 14, marginTop: 20 }}>
            <img src={TESTIMONIALS[active].avatar} alt={TESTIMONIALS[active].name} style={{ width: 52, height: 52, borderRadius: "50%", objectFit: "cover", border: "3px solid #BFDBFE" }} />
            <div style={{ textAlign: "left" }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#0F172A", fontFamily: "'Sora',sans-serif" }}>{TESTIMONIALS[active].name}</div>
              <div style={{ fontSize: 13, color: "#6B7280" }}>{TESTIMONIALS[active].role}</div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 28 }}>
          {TESTIMONIALS.map((_, i) => (
            <button key={i} onClick={() => setActive(i)} style={{
              width: i === active ? 28 : 10, height: 10, borderRadius: 99,
              background: i === active ? "#3B82F6" : "#D1D5DB",
              border: "none", cursor: "pointer", transition: "all .3s",
            }} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Blog() {
  return (
    <section style={{ padding: "96px 40px", background: "#fff" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16, marginBottom: 48 }}>
          <div>
            <Badge color="#F59E0B">Blog & Insights</Badge>
            <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(26px,4vw,40px)", fontWeight: 800, color: "#0F172A", margin: "16px 0 0" }}>
              Latest from Our Blog
            </h2>
          </div>
          <a href="/blogs" style={{ color: "#3B82F6", fontWeight: 700, textDecoration: "none", fontSize: 14 }}>View all posts →</a>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 28 }}>
          {BLOG_POSTS.map((post, i) => (
            <article key={post.title} style={{
              borderRadius: 20, overflow: "hidden", border: "1px solid #F1F5F9",
              transition: "all .3s ease", cursor: "pointer",
              animation: `fadeIn .5s ease ${i * .1}s both`,
            }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 16px 48px rgba(0,0,0,.1)"; e.currentTarget.style.transform = "translateY(-4px)"; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
            >
              <a href={post.link} style={{ textDecoration: 'none' }}>
                <div style={{ position: "relative", overflow: "hidden" }}>
                  <img src={post.img} alt={post.title} style={{ width: "100%", height: 200, objectFit: "cover", transition: "transform .4s" }}
                    onMouseEnter={e => e.target.style.transform = "scale(1.05)"}
                    onMouseLeave={e => e.target.style.transform = "none"}
                  />
                  <div style={{ position: "absolute", top: 14, left: 14 }}>
                    <Badge color="#3B82F6">{post.category}</Badge>
                  </div>
                </div>
              </a>
              <div style={{ padding: "24px" }}>
                <div style={{ display: "flex", gap: 12, marginBottom: 10, fontSize: 12, color: "#9CA3AF" }}>
                  <span>📅 {post.date}</span>
                  <span>⏱ {post.readTime} read</span>
                </div>
                <a href={post.link} style={{ textDecoration: 'none' }}>
                  <h3 style={{ fontFamily: "'Sora',sans-serif", fontSize: 16.5, fontWeight: 700, color: "#0F172A", lineHeight: 1.4, marginBottom: 10 }}>{post.title}</h3>
                </a>
                <p style={{ fontSize: 13.5, color: "#6B7280", lineHeight: 1.65 }}>{post.excerpt}</p>
                <a href={post.link} style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 16, color: "#3B82F6", fontWeight: 600, fontSize: 13, textDecoration: "none" }}>Read article →</a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="cta-section" style={{
      margin: "0 40px 80px", borderRadius: 24,
      background: "linear-gradient(135deg,#1E3A8A 0%,#3B82F6 50%,#06B6D4 100%)",
      padding: "72px 48px", textAlign: "center", position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle at 20% 50%,rgba(255,255,255,.05) 0%,transparent 50%),radial-gradient(circle at 80% 20%,rgba(255,255,255,.05) 0%,transparent 50%)", pointerEvents: "none" }} />
      <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(28px,4vw,48px)", fontWeight: 900, color: "#fff", marginBottom: 16, position: "relative" }}>
        Ready to Join the 1,560+?
      </h2>
      <p style={{ color: "rgba(255,255,255,.8)", fontSize: 17, maxWidth: 520, margin: "0 auto 40px", lineHeight: 1.7, position: "relative" }}>
        Let's build your next transformative digital product — fast, beautiful, and built to last.
      </p>
      <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap", position: "relative" }}>
        <a href="#contact" style={{
          background: "#fff", color: "#1E3A8A",
          padding: "15px 32px", borderRadius: 10, fontWeight: 800, fontSize: 15,
          textDecoration: "none", boxShadow: "0 8px 24px rgba(0,0,0,.2)",
          transition: "transform .2s", fontFamily: "'Sora',sans-serif",
        }}
          onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
          onMouseLeave={e => e.currentTarget.style.transform = "none"}
        >🚀 Start a Project</a>
        <a href="tel:+919646206032" style={{
          background: "rgba(255,255,255,.15)", color: "#fff",
          padding: "15px 32px", borderRadius: 10, fontWeight: 700, fontSize: 15,
          textDecoration: "none", border: "2px solid rgba(255,255,255,.3)",
          transition: "all .2s", fontFamily: "'Sora',sans-serif",
        }}
          onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,.25)"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,.15)"; }}
        >📞 Call Us Now</a>
      </div>
    </section>
  );
}

// ── Root App ──────────────────────────────────────────────────────────────────
function HomePage() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800;900&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        body { font-family: 'Sora', -apple-system, sans-serif; background: #fff; color: #0F172A; overflow-x: hidden; }

        /* ── Animations ── */
        @keyframes fadeIn  { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:none; } }
        @keyframes float   { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-10px); } }
        @keyframes pulse   { 0%,100% { opacity:1; } 50% { opacity:.4; } }
        @keyframes blink   { 0%,100% { opacity:1; } 50% { opacity:0; } }
        @keyframes marquee { from { transform:translateX(0); } to { transform:translateX(-50%); } }
        @keyframes spin    { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }

        /* ── Base layout helpers ── */
        .hero-grid       { display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; }
        .about-grid      { display:grid; grid-template-columns:1fr 1fr; gap:72px; align-items:center; }
        .footer-grid     { display:grid; grid-template-columns:2fr 1fr 1fr 1fr; gap:48px; }
        .services-grid   { display:grid; grid-template-columns:repeat(auto-fit,minmax(300px,1fr)); gap:24px; }
        .tech-grid       { display:grid; grid-template-columns:repeat(auto-fill,minmax(150px,1fr)); gap:18px; }
        .process-grid    { display:grid; grid-template-columns:repeat(5,1fr); gap:0; position:relative; }
        .blog-grid       { display:grid; grid-template-columns:repeat(auto-fit,minmax(300px,1fr)); gap:28px; }
        .stats-grid      { display:grid; grid-template-columns:repeat(4,1fr); gap:40px; }
        .nav-links       { display:flex; align-items:center; gap:4px; }
        .nav-cta         { display:flex !important; }
        .mob-menu-btn    { display:none; }
        .float-card-tech { display:block !important; }

        /* ── Unified Contact Layout Styles ── */
        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1.35fr;
          align-items: stretch;
          background: #fff;
          border-radius: 24px;
          box-shadow: 0 16px 48px rgba(0,0,0,.06);
          border: 1px solid #E5E7EB;
          overflow: hidden;
        }
        .info-panel { padding: 48px 44px; }
        .form-panel { padding: 48px 52px; }
        .form-row   { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }

        /* ── Large tablets / small laptops (max 1100px) ── */
        @media (max-width:1100px) {
          .hero-grid     { grid-template-columns:1fr 1fr; gap:36px; }
          .footer-grid   { grid-template-columns:1fr 1fr; gap:32px; }
          .stats-grid    { grid-template-columns:repeat(2,1fr); }
          .process-grid  { grid-template-columns:repeat(3,1fr); gap:24px; }
          .hero-float-left  { left: 0 !important; }
          .hero-float-right { right: 0 !important; }
        }

        /* ── Tablets (max 900px) ── */
        @media (max-width:900px) {
          .hero-grid     { grid-template-columns:1fr; gap:48px; }
          .about-grid    { grid-template-columns:1fr; gap:36px; }
          .contact-grid  { grid-template-columns:1fr; }
          .form-row      { grid-template-columns:1fr; }
          .form-panel    { padding: 40px 32px; }
          .footer-grid   { grid-template-columns:1fr 1fr; gap:32px; }
          .process-grid  { grid-template-columns:repeat(2,1fr); gap:24px; }
          .nav-links     { display:none !important; }
          .nav-cta       { display:none !important; }
          .mob-menu-btn  { display:flex !important; }
          .float-card-tech { left: 0 !important; right:auto; bottom:-10px !important; min-width:190px !important; }
          .hero-svg-wrap img { height: 340px !important; }
        }

        /* ── Mobile (max 640px) ── */
        @media (max-width:640px) {
          .hero-grid     { grid-template-columns:1fr; gap:36px; }
          .footer-grid   { grid-template-columns:1fr; }
          .stats-grid    { grid-template-columns:repeat(2,1fr); gap:24px; }
          .process-grid  { grid-template-columns:1fr 1fr; gap:20px; }
          .services-grid { grid-template-columns:1fr; }
          .tech-grid     { grid-template-columns:repeat(auto-fill,minmax(120px,1fr)); gap:12px; }
          .blog-grid     { grid-template-columns:1fr; }
          .float-card-tech { display:none !important; }
          .info-panel    { padding: 36px 24px; }
          .form-panel    { padding: 36px 24px; }
          .hero-svg-wrap img { height: 220px !important; }

          /* Floating cards on small screens */
          .hero-float-left  { left:4px !important; top:auto !important; bottom:-8px !important; min-width:160px !important; padding: 10px 12px !important; }
          .hero-float-right { right:4px !important; top:8px !important; padding: 10px 14px !important; }
          .hero-float-br    { right:4px !important; display:none !important; }
        }

        /* ── XS Mobile (max 400px) ── */
        @media (max-width:400px) {
          .stats-grid   { grid-template-columns:1fr 1fr; gap:16px; }
          .process-grid { grid-template-columns:1fr; }
          .form-row     { grid-template-columns:1fr; }
          .hero-float-left  { display:none !important; }
          .hero-float-right { display:none !important; }
        }

        /* ── Section padding responsive ── */
        @media (max-width:900px) {
          .section-pad { padding-left:20px !important; padding-right:20px !important; }
          .cta-section { margin:0 16px 48px !important; padding:48px 24px !important; }
        }
        @media (max-width:640px) {
          .section-pad { padding-left:16px !important; padding-right:16px !important; padding-top:64px !important; padding-bottom:64px !important; }
          .cta-section { margin:0 12px 40px !important; padding:40px 20px !important; }
        }

        /* ── Navbar top bar hide on xs ── */
        @media (max-width:500px) {
          .topbar-right { display:none !important; }
        }

        /* ── Navbar padding on mobile ── */
        @media (max-width:640px) {
          nav > div:nth-child(2) { padding: 0 16px !important; }
          nav > div:first-child  { padding: 6px 16px !important; }
        }

        /* ── Hero section padding on mobile ── */
        @media (max-width:640px) {
          .hero-grid { padding: 0 16px 60px !important; }
        }

        /* ── Process connector line hide on small ── */
        @media (max-width:900px) {
          .process-line { display:none !important; }
        }

        /* ── Footer bottom text ── */
        @media (max-width:500px) {
          .footer-bottom { flex-direction:column !important; text-align:center; gap:6px; }
        }

        /* ── Tab buttons wrap ── */
        .tech-tabs { display:flex; justify-content:center; gap:10px; flex-wrap:wrap; margin-bottom:44px; }

        /* ── Contact info grid ── */
        .contact-info-items { display:flex; flex-direction:column; gap:0; }

        /* ── Testimonial card padding ── */
        @media (max-width:640px) {
          .testi-card { padding:28px 20px !important; }
        }

        /* ── Testimonial card padding (inline) ── */
        @media (max-width:640px) {
          section[style*="padding: 96px 40px"][style*="F8FAFC"] .testi-inner {
            padding: 28px 20px !important;
          }
        }

        /* ── General section horizontal padding on mobile ── */
        @media (max-width:640px) {
          section { padding-left: 16px !important; padding-right: 16px !important; }
          footer  { padding-left: 16px !important; padding-right: 16px !important; }
        }

        /* ── About grid badges on mobile ── */
        @media (max-width:640px) {
          .about-grid > div:first-child { display:none; }
        }

        /* ── Services grid on very small screens ── */
        @media (max-width:480px) {
          section#services > div > div:last-child {
            grid-template-columns: 1fr !important;
          }
        }

        /* ── Fix hero banner height on tablet ── */
        @media (max-width:768px) {
          .hero-svg-wrap { margin-top: 16px; }
        }

        /* ── Footer grid on mobile ── */
        @media (max-width:480px) {
          .footer-grid { grid-template-columns: 1fr !important; gap: 28px; }
        }

        /* ── Tech category tabs scroll on mobile ── */
        @media (max-width:640px) {
          .tech-tabs-wrap {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            justify-content: flex-start !important;
            padding-bottom: 4px;
          }
          .tech-tabs-wrap::-webkit-scrollbar { display: none; }
        }
      `}</style>
      <Hero />
      <ClientLogos />
      <Stats />
      <Services />
      <About />
      <TechStack />
      <Process />
      <Testimonials />
      <Blog />
      <CTA />
    </>
  );
}

// ── Root Routing App ──────────────────────────────────────────────────────────────────
export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blogs" element={<AllBlogs />} />
        <Route path="/blog/:slug" element={<BlogPage />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/mobile-app-development" element={<MobileAppDevelopment />} />
        <Route path="/ai-ml-solutions" element={<AiMlSolutions />} />
        <Route path="/cloud" element={<Cloud />} />
        <Route path="/ecommerce" element={<Ecommerce />} />
        <Route path="/ui-ux" element={<UIUX />} />
        <Route path="/crm-solutions" element={<CRM />} />
        <Route path="/erp-solutions" element={<ERP />} />
        <Route path="/hrm-solutions" element={<HRM />} />
        <Route path="/lms-solutions" element={<LMS />} />
        <Route path="/pos-solutions" element={<POS />} />
        <Route path="/saas-platform" element={<SAAS />} />
        <Route path="/healthcare-solution" element={<Healthcare />} />
        <Route path="/fintech-solution" element={<Fintech />} />
        <Route path="/edtech-solution" element={<Edtech />} />
        <Route path="/realestate-solution" element={<Realestate />} />
        <Route path="/logistic-solution" element={<Logistic />} />
        <Route path="/retail-ecommerce-solution" element={<Retail />} />

      </Route>
    </Routes>
  );
}